export const GET_MEMBERS = 'GET_MEMBERS';
export const RESET_MEMBERS = 'RESET_MEMBERS';
export const GET_MEMBERS_ERROR = 'GET_MEMBERS_ERROR';
export const GET_MEMBERS_LOADING = 'GET_MEMBERS_LOADING';
export const GET_MEMBER_CHECKED_IN = 'GET_MEMBER_CHECKED_IN';
